import { AboveKeyboard } from "@-/dev.improve.haniverse.components.above-keyboard";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import {
  ToolbarGlassSurface,
  useToolbarGridMetrics,
} from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { PERSISTENT_KEYBOARD_TOOLBAR_PORTAL_HOST_NAME } from "@-/dev.improve.haniverse.modules.persistent-keyboard";
import { Pressable, View } from "@-/com.npmjs.react-native";
import { Portal } from "@-/com.npmjs.react-native-teleport";
import { persistentKeyboardDismiss } from "#persistent-keyboard-runtime";
import type { PersistentKeyboardDismissButtonGate } from "#use-persistent-keyboard-dismiss-button-gate";

const CONTINUOUS_BORDER_CURVE_STYLE = { borderCurve: "continuous" } as const;

/**
 * App-wide keyboard dismiss control. It lives once at the root rather than inside an answer input
 * because the persistent keyboard deliberately survives review route hops where that input is not
 * mounted. Keeping the control global guarantees an escape hatch whenever any OS keyboard is up.
 */
export function PersistentKeyboardDismissButton(_props: {
  gate: PersistentKeyboardDismissButtonGate;
}) {
  const { diameter } = useToolbarGridMetrics();

  return (
    <Portal hostName={PERSISTENT_KEYBOARD_TOOLBAR_PORTAL_HOST_NAME} name="toolbar">
      <AboveKeyboard className="px-2.25" floating primaryNavigationStripOffset={false}>
        <View className="flex-1 flex-row items-center justify-start" pointerEvents="box-none">
          <ToolbarGlassSurface>
            <Pressable
              accessibilityHint="Hides the answer keyboard"
              accessibilityLabel="Collapse keyboard"
              accessibilityRole="button"
              className="items-center justify-center rounded-full"
              hitSlop={8}
              onPress={() => {
                persistentKeyboardDismiss();
              }}
              style={[CONTINUOUS_BORDER_CURVE_STYLE, { height: diameter, width: diameter }]}
            >
              <Icon className="text-foreground" name="LuChevronDown" size={20} />
            </Pressable>
          </ToolbarGlassSurface>
        </View>
      </AboveKeyboard>
    </Portal>
  );
}
